/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */

import React from "react";
import Discuss from "parts/Discuss";
import Button from "elements/Button";
import BenefitsSection from "components/BenefitsSection";

export default function HardwareAsAService() {
  return (
    <>
      {/* FEATURES SECTION */}
      <section className="py-20 bg-premium-light">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl lg:text-4xl text-surface-900 font-extrabold text-center mb-6 tracking-tight">
            What HaaS Includes
          </h2>
          <p className="text-center text-surface-300 text-lg mb-12">
            All the hardware your business needs, fully managed, upgraded and supported.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                No Upfront Costs
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Get new equipment without the budget strain — one simple monthly payment covers everything.
              </p>
            </div>

            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Automatic Hardware Upgrades
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Stay current with the latest hardware — replaced and upgraded automatically at no extra charge.
              </p>
            </div>

            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Full Support & Warranty
              </h3>
              <p className="text-surface-300 leading-relaxed">
                If something breaks, we fix or replace it fast — no unexpected costs, ever.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFITS SECTION (Reusable) */}
      <BenefitsSection
        title="Why Choose HaaS?"
        subtitle="Hardware as a Service removes capital expenses and keeps your technology always current."
        benefits={[
          {
            id: "predictable-budget",
            title: "Predictable Monthly IT Budget",
            text: "Hardware, installation, maintenance, upgrades and support — all included.",
            delay: 0,
          },
          {
            id: "no-failures",
            title: "Eliminate Surprise Failures",
            text: "If hardware fails, it’s replaced immediately at no cost to your business.",
            delay: 120,
          },
          {
            id: "scalability",
            title: "Scale Easily",
            text: "Add or remove devices as your business grows — without capital expenses.",
            delay: 240,
          },
        ]}
        gainsTitle="Typical Outcomes"
        gains={[
          { id: "zero-capex", text: "Zero capital expenditure" },
          { id: "always-current", text: "Always up-to-date hardware" },
          { id: "lower-risk", text: "Lower operational risk" },
          { id: "productivity", text: "Improved reliability and productivity" },
        ]}
      />

      {/* CTA SECTION */}
      <section className="py-20 bg-premium-accent">
        <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-2xl lg:text-3xl text-surface-900 font-extrabold tracking-tight">
              Want predictable hardware costs?
            </h2>
            <p className="text-surface-300 mt-2 text-lg">
              Let us manage, upgrade and support your equipment — all for one monthly fee.
            </p>
          </div>

          <Button
            href="/contact"
            type="link"
            className="btn-premium text-base px-8 py-4"
          >
            Book a Consultation
          </Button>
        </div>
      </section>

      <Discuss />
    </>
  );
}
